import axios from 'axios'
import { toast } from 'react-toastify';
// const baseURLs: string = process.env.REACT_APP_API_ENDPOINT as string;

// export const baseURLLocal = 'https://localhost:7068/api/';
export const baseURLLocal = 'https://api.wocons.com:8443/api/';   //live


//#region Auth Login

const API = axios.create({
    baseURL: baseURLLocal,
    headers: {
        'Content-Type': 'application/json',
    },
});

API.interceptors.request.use(config => {
    const token = sessionStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
});

export const loginApi = async (email: string, password: string) => {
    const response = await API.post("Auth/login", {
        email,
        password,
    });
    return response.data;
};

//#endregion

//#region Create enquiry

export const createEnquiry = async (data: any) => {
    const response = await API.post("Enquiry/create", data);
    return response.data;
};
//#endregion

//#region Admin

export const getAllEnquiriesApi = async () => {
  const response = await API.get("Admin/allEnq");
  return response.data;
};

export const getAllUsersApi = async () => {
  try {
    const response = await API.get("Admin/allUser");
    return response.data;
  } catch (error: any) {
    toast.error(error.response?.data || error.message);
    console.error("Error fetching users:", error.response?.data || error.message);
    throw error;
  }
};

export const createUserApi = async (data: {
  name: string;
  email: string;
  password: string;
  phoneNumber: string;
  gender: string;
  role: string;
}) => {
  try {
    const response = await API.post("Admin/create-user", data);
    return response.data;
  } catch (error: any) {
    toast.error("Error creating user:", error.response?.data || error.message);
    throw error;
  }
};

// ================= USERS =================

export const updateUserApi = async (id: string, data: any) => {
  const response = await API.put(`Admin/update-user/${id}`, data);
  return response.data;
};

export const deleteUserApi = async (id: string) => {
  const response = await API.delete(`Admin/delete-user/${id}`);
  return response.data;
};

export const toggleUserStatusApi = async (id: string) => {
  const response = await API.patch(`Admin/toggle-status/${id}`);
  return response.data;
};

export const resetPasswordApi = async (id: string, newPassword: string) => {
  const response = await API.patch(`Admin/reset-password/${id}`, {
    newPassword
  });
  return response.data;
};

export const assignEnquiryApi = async (
  EID: string,
  coordinatorId: string
) => {
  return API.put("/Enquiry/assign", {
    EID,
    coordinatorId
  });
};
//#endregion

//#region Admin Dashboard

export const getAdminDashboardApi = async () => {
  const response = await API.get("Admin/admin");
  return response.data;
};

export const getCoordinatorPerformanceApi = async () => {
  const response = await API.get("Admin/coordinator-performance");
  return response.data;
};

export const getMonthlyRevenueApi = async () => {
  const response = await API.get("Admin/monthly-revenue");
  return response.data;
};

export const getAnalyticsApi = async (from: string, to: string) => {
  const response = await API.get(
    `Admin/analytics?from=${from}&to=${to}`
  );
  return response.data;
};
export const getKpiComparisonApi = async () => {
  const response = await API.get("Admin/kpi-comparison");
  return response.data;
};

export const getNotificationsApi = async () => {
  const response = await API.get("Notification/my");
  return response.data;
};
export const markNotificationReadApi = async (id: number) => {
  return await API.put(`Notification/mark-read/${id}`);
};

export const markAllNotificationsReadApi = async () => {
  return await API.put("Notification/mark-all-read");
};

export const getUnreadCountApi = async () => {
  const response = await API.get("Notification/unread-count");
  return response.data;
};

export const getCoordinatorDetailsApi = async (name: string) => {
  const response = await API.get(`Admin/coordinator-details/${name}`);
  return response.data;
};

export const getEnquiryDetailsApi = async (eid: any) => {
  const res = await API.get(`/Enquiry/details/${eid}`);
  return res.data;
};


export const createContact = async (data: any) => {
  const response = await API.post("Auth/contact-enq", data);
  return response.data;
};
export const getContacts = async () => {
  const response = await API.get("Admin/contact-enq");
  // eslint-disable-next-line
  return response. data;
};




//#endregion

//#region Coordinator Dashboard
export const getCoordinatorDashboardApi = async () => {
  const response = await API.get("Dashboard/coordinator");
  return response.data;
};
//#endregion
//#region Coordinator Enquiries
// Get My Assigned Enquiries
export const getMyEnquiriesApi = async () => {
  const response = await API.get("Enquiry/my-enquiries");
  return response.data;
};

// Edit Enquiry (Coordinator only)
export const editEnquiryApi = async (id: number, data: any) => {
  const response = await API.put(`Enquiry/edit/${id}`, data);
  return response.data;
};
//#endregion

//#region FollowUp APIs
// Add FollowUp
export const addFollowUpApi = async (data: any) => {
  const response = await API.post("FollowUp/followup", data);
  return response.data;
};

// Get FollowUps By Enquiry
export const getFollowUpsByEnquiryApi = async (enqId: number) => {
  const response = await API.get(`FollowUp/by-enquiry/${enqId}`);
  return response.data;
};

// Update FollowUp
export const updateFollowUpApi = async (id: number, data: any) => {
  const response = await API.put(`FollowUp/${id}`, data);
  return response.data;
};

// Delete FollowUp
export const deleteFollowUpApi = async (id: number) => {
  const response = await API.delete(`FollowUp/${id}`);
  return response.data;
};
//#endregion

//#region Payment APIs
// Add Payment
export const addPaymentApi = async (data: any) => {
  const response = await API.post("Payment/add", data);
  return response.data;
};

// Get Payment History
export const getPaymentHistoryApi = async (enqId: number) => {
  const response = await API.get(`Payment/history/${enqId}`);
  return response.data;
};

// Get Fees List (Coordinator sees own)
export const getFeesListApi = async () => {
  const response = await API.get("Payment/fees");
  return response.data;
};
export const getbatchFeesListApi = async () => {
  const response = await API.get("Payment/batchfees");
  return response.data;
};

export const getAllEnquiriesCoordinatorApi = async () => {
  const response = await API.get("Enquiry/all");
  return response.data;
};

export const getMyFollowUpsApi = async () => {
  const response = await API.get("FollowUp/my");
  return response.data;
};

//#endregion
// //#region Batch APIs
 
// export const createBatchApi = async (data: {
//   batchName: string;
//   course1Name: string;
//   course1Trainer: string;
//   b1StartDate: string;
//   b1EndDate: string;
//   batch1Status: string;
//   course2Name: string;
//   course2Trainer: string;
//   b2StartDate: string;
//   b2EndDate: string;
//   batch2Status: string;
// }) => {
//   const response = await API.post("Batch/create", data);
//   return response.data;
// };
 
//#endregion
 
//#region Batch APIs
 
// Create Batch
export const createBatchApi = async (data: any) => {
  const response = await API.post("Batch/create", data);
  return response.data;
};
 
// Get All Batches
export const getAllBatchesApi = async () => {
  const response = await API.get("Batch");
  return response.data;
};
 
// Get Batch Details
export const getBatchDetailsApi = async (id: number) => {
  const response = await API.get(`Batch/details/${id}`);
  return response.data;
};
 
// Update Batch
export const updateBatchApi = async (id: number, data: any) => {
  const response = await API.put(`Batch/update/${id}`, data);
  return response.data;
};
 
// Get Students in Batch
export const getBatchStudentsApi = async (batchId: number) => {
  const response = await API.get(`Batch/${batchId}/students`);
  return response.data;
};
 
// Get Available Students (not assigned to batch)
export const getAvailableStudentsApi = async (batchId: number) => {
  const response = await API.get(`Batch/available-students/${batchId}`);
  return response.data;
};
 
// Add Student to Batch
export const addStudentToBatchApi = async (
  batchId: number,
  enqFormId: number
) => {
  const response = await API.post(
    `Batch/add-student?batchId=${batchId}&enqFormId=${enqFormId}`
  );
 
  return response.data;
};
// Remove Student from Batch
export const removeStudentFromBatchApi = async (id: number) => {
  const response = await API.delete(`Batch/remove-student/${id}`);
  return response.data;
};
 
// Move Student to Another Batch
export const moveStudentBatchApi = async (
  batchStudentId: number,
  newBatchId: number
) => {
  const response = await API.put(
    `Batch/move-student?batchStudentId=${batchStudentId}&newBatchId=${newBatchId}`
  );
  return response.data;
};
 
// Batch Dashboard
export const getBatchDashboardApi = async () => {
  const response = await API.get("Batch/dashboard");
  return response.data;
};
 
// Search Batch
export const searchBatchApi = async (name: string) => {
  const response = await API.get(`Batch/search?name=${name}`);
  return response.data;
};
 
//#endregion
//#region Log


// enquiry logs
export const getEnquiryLogsApi = async (id: string) => {
  const res = await API.get(`ActivityLog/enquiry/${id}`);
  return res.data;
};

// batch logs
export const getBatchLogsApi = async (id: string) => {
  const res = await API.get(`ActivityLog/batch/${id}`);
  return res.data;
};

// payment logs for enquiry
export const getPaymentLogsApi = async (id: string) => {
  const res = await API.get(`ActivityLog/payment/enquiry/${id}`);
  return res.data;
};

// overall logs
export const getAllLogsApi = async (page = 1) => {
  const res = await API.get(`ActivityLog/all?page=${page}&pageSize=50`);
  return res.data;
};


//#endregion


//#region Dashboard Users

export const getAllDashboardUsersApi = async () => {
  try {
    const response = await API.get("Dashboard/alluser");
    return response.data;
  } catch (error: any) {
    toast.error(error.response?.data || error.message);
    console.error("Error fetching dashboard users:", error);
    throw error;
  }
};

//#endregion

//#region Batch Dashboard APIs

// Total Batches
export const getBatchTotalApi = async () => {
  const response = await API.get("Batch/Batch-Total");
  return response.data;
};

// Not Started Batches
export const getBatchNotStartedApi = async () => {
  const response = await API.get("Batch/notstarted");
  return response.data;
};

// Upcoming Batches
export const getBatchUpcomingApi = async () => {
  const response = await API.get("Batch/upcoming");
  return response.data;
};

// Ongoing Batches
export const getBatchOngoingApi = async () => {
  const response = await API.get("Batch/ongoing");
  return response.data;
};

// Completed Batches
export const getBatchCompletedApi = async () => {
  const response = await API.get("Batch/completed");
  return response.data;
};

//#endregion



   